import { t } from '../../utils/i18n';
import { HOW_IT_WORKS_PHOTOS } from './constants';

const STEPS = [
  { step: 1, key: 'step1', photo: HOW_IT_WORKS_PHOTOS.search, accent: 'primary' },
  { step: 2, key: 'step2', photo: HOW_IT_WORKS_PHOTOS.contact, accent: 'primary' },
  { step: 3, key: 'step3', photo: HOW_IT_WORKS_PHOTOS.start, accent: 'olive' },
];

export default function HowItWorks() {
  return (
    <section className="relative z-20 py-12 sm:py-14 lg:py-16 landing-section-soft">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-10">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-[var(--color-text)] mb-2 tracking-tight">
            {t('landing.howItWorks.title')}
          </h2>
          <p className="text-base sm:text-lg text-[var(--color-text-muted)] max-w-2xl mx-auto">
            {t('landing.howItWorks.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-6">
          {STEPS.map((s) => (
            <article
              key={s.step}
              className="landing-step-card group flex flex-col rounded-2xl overflow-hidden transition-all duration-300 focus-within:ring-2 focus-within:ring-primary-500/30"
            >
              <div className="relative aspect-[4/3] overflow-hidden flex-shrink-0">
                <img
                  src={s.photo.src}
                  alt={s.photo.alt}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
                  loading="lazy"
                  referrerPolicy="no-referrer"
                />
                <div className="absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-black/50 to-transparent pointer-events-none" />
                <div
                  className={`absolute top-3 left-3 landing-step-badge ${
                    s.accent === 'olive' ? 'landing-step-badge--olive' : ''
                  }`}
                >
                  <span className="text-sm font-bold">{s.step}</span>
                </div>
              </div>
              <div className="flex flex-col flex-1 p-4 sm:p-5">
                <h3 className="text-base sm:text-lg font-semibold text-[var(--color-text)] mb-1.5">
                  {t(`landing.howItWorks.${s.key}.title`)}
                </h3>
                <p className="text-sm text-[var(--color-text-muted)] leading-relaxed flex-1">
                  {t(`landing.howItWorks.${s.key}.desc`)}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
